import * as React from 'react'
import Modal from '../components/modal'
import { Helmet } from 'react-helmet'

const IndexPage = () => {
  return (
    <>
      <Helmet>
        <title>Pilipinas Pantry Network</title>
      </Helmet>
      <main className="bg-main-1 h-screen">
        <Modal view="list" />
      </main>
    </>
  )
}

export default IndexPage
